import { makeStyles } from '@mui/styles';
import { NextTheme } from '../../../../ui/layout/theme-next/provider';

interface StyleProps {
  isCreateUrl: boolean
}

export default makeStyles<NextTheme, StyleProps>((theme) => ({
  content: {
    overflowY: 'auto',
    margin: theme.spacing(-4.5, -2, 0),
    padding: ({ isCreateUrl }) => theme.spacing(!isCreateUrl ? 8 : 6.5, 2, 0),
  },
  bomTabContent: {
    overflowY: 'auto',
    margin: theme.spacing(-4.5, -2, 0),
    padding: theme.spacing(6.7, 2, 0),
  },
}));
